import { mapGetters, mapMutations } from 'vuex'

// Draft preview mode (?draftPreview=1 on the trust center URL). Captured once
// at the first init because SPA navigation drops the query param: re-fetches
// (NDA signing, questionnaire upload, request access) must stay in preview
// mode instead of silently reverting to the published data until reload
let draftPreview

export default {
  computed: {
    ...mapGetters(["GET_CURRENT_USER"]),
  },
  methods: {
    ...mapMutations(["SET_TRUST_CENTER_DB", "SET_TEAMID", "SET_MAIN_LOADER", "SET_TRUST_CENTER_SHARES_DB", "SET_PRODUCTS_LIST_TRUST", "SET_SUBSCRIPTIONS"]),

    auditLogCreate(payload) {
      try {
        console.log('Inside auditLogCreate : payload', payload)
        // Fire-and-forget on purpose, but the rejection must be handled here:
        // without .catch() a failed POST escapes this try/catch (it only covers
        // the synchronous part) and surfaces as an unhandled rejection in Sentry
        let response = this.$axios.post('trust-center/log', payload)
          .catch((error) => console.error('Error creating audit log', error))
        console.log('Inside auditLogCreate : response', response)
      } catch (error) {
        console.error('Error creating audit log', error)
      }
    },
    async fetchTrustCenterData(withLoading, url = 'trust-center/init') {
      console.log('Inside fetchTrustCenterData : url', url)
      if(withLoading) this.SET_MAIN_LOADER(true) // Show loader only on the first load
      try {
        // Forward the draft-preview flag on every init/re-fetch so the backend
        // serves the live docs merged with pending drafts instead of the
        // published cache
        if (this.$route?.query?.draftPreview) draftPreview = this.$route.query.draftPreview
        const params = draftPreview ? { draftPreview } : {}
        let response = await this.$axios.get(url, { params })

        console.log('Inside fetchTrustCenterData : response', response.data.trustCenter, response.data.trustCenterShares)

        this.SET_TRUST_CENTER_DB(response.data.trustCenter)
        this.SET_PRODUCTS_LIST_TRUST(response.data.products)
        this.SET_TRUST_CENTER_SHARES_DB(response.data.trustCenterShares)
        this.SET_SUBSCRIPTIONS(response.data.subscriptions)
        this.SET_TEAMID(_.get(response, 'data.trustCenter[0].tid', ''))
        console.log('SET_MAIN_LOADER(false) fetchTrustCenterData')
      } catch (error) {
        console.error('Error setting trust center data SET_MAIN_LOADER(false)', error)
        this.SET_MAIN_LOADER(false)
        // Logout only when the backend actually rejected the session (401/403).
        // A network error has no response (status 0) — e.g. connection drop or
        // corporate proxy blocking api.vendict.com — and must not log the user out
        const status = error?.response?.status
        if (status === 401 || status === 403) {
          this.logout()
        }
      }


    },
  }
}
